;(function() {
  'use strict'

  angular
    .module('glow.reporting')
    .component('glQuestionMoodFilter', Component())

  function Component() {
    return {
      controller: Controller,
      templateUrl: 'mood-filter.template.html',
      bindings: {
        question: '=',
        filter: '=',
      },
    }
  }

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.toggle = toggle

    function onInit() {
      if (ctrl.filter.newValue) {
        var choice = _.find(ctrl.question.choices, {
          displayLabel: ctrl.filter.newValue,
        })
        if (choice) {
          ctrl.filter.data.values.push({ id: choice.id })
        }
        ctrl.filter.newValue = undefined
      }

      _.each(ctrl.filter.data.values, function(choice) {
        var questionChoice = _.find(ctrl.question.choices, { id: choice.id })
        questionChoice.isSelected = true
      })
    }

    function toggle(choice) {
      if (choice.isSelected) {
        ctrl.filter.data.values.push({ id: choice.id })
      } else {
        _.remove(ctrl.filter.data.values, { id: choice.id })
      }
    }
  }
})()
